var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container", attrs: { id: "goods-edit" } }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("矩阵管理")]),
            ]),
            _c("el-breadcrumb-item", { attrs: { to: { path: "/user" } } }, [
              _c("div", { staticClass: "div2" }, [_vm._v("用户信息")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content page-title" },
      [
        _c(
          "el-menu",
          {
            staticClass: "el-menu-demo",
            attrs: { "default-active": _vm.currentIndex, mode: "horizontal" },
            on: { select: _vm.clickbtn },
          },
          _vm._l(_vm.btns, function (item, index) {
            return _c(
              "el-menu-item",
              { key: index, attrs: { index: index.toString() } },
              [_vm._v(_vm._s(item))]
            )
          }),
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("h2", [_vm._v("用户详情")]),
        _vm.currentIndex == 0
          ? _c("userInfo", { attrs: { id: _vm.userId } })
          : _vm._e(),
        _vm.currentIndex == 1
          ? _c("orderInfo", { attrs: { id: _vm.userId } })
          : _vm._e(),
        _vm.currentIndex == 2
          ? _c("addressInfo", { attrs: { id: _vm.userId } })
          : _vm._e(),
        _vm.currentIndex == 3
          ? _c("commissionRecord", { attrs: { id: _vm.userId } })
          : _vm._e(),
        _vm.currentIndex == 4
          ? _c("fansRecord", { attrs: { id: _vm.userId } })
          : _vm._e(),
        _vm.currentIndex == 5
          ? _c("cashRecord", { attrs: { id: _vm.userId } })
          : _vm._e(),
        _vm.currentIndex == 6
          ? _c("couponRecord", { attrs: { id: _vm.userId } })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }